import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HowItWorksSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '1',
    title: 'Audita tu luz',
    description: 'Sigue el ejercicio del mapa solar para saber qué puedes plantar realmente.'
  }, {
    number: '2',
    title: 'Monta tus 3 Macetas',
    description: 'Usa nuestra receta de sustrato y las especies velocistas recomendadas.'
  }, {
    number: '3',
    title: 'Cosecha y Repite',
    description: "Aplica la técnica 'Corta y Vuelve' para tener comida infinita durante toda la temporada."
  }];
  return <section ref={ref} className="w-full py-10 md:py-16 bg-white" data-id="element-119">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-121">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#2D6A4F] mb-3" data-id="element-122">
            Cómo Funciona
          </h2>
          <p className="text-sm text-gray-600 max-w-2xl mx-auto" data-id="element-123">
            Tres pasos simples para tu primera cosecha
          </p>
        </motion.div>

        <div className="space-y-5" data-id="element-124">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2 + index * 0.1
        }} className="flex gap-4 items-start" data-id="element-125">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#2D6A4F] to-[#40916C] rounded-full flex items-center justify-center shadow-lg" data-id="element-126">
                <span className="text-xl font-bold text-white" data-id="element-127">
                  {step.number}
                </span>
              </div>
              <div className="flex-1 bg-[#D8F3DC] rounded-xl p-4" data-id="element-128">
                <h3 className="font-heading text-lg md:text-xl font-bold text-[#2D6A4F] mb-1" data-id="element-129">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-130">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}